import React, { useEffect, useState } from "react";
import search from "../../assets/images/search-lg.svg";
import filter from "../../assets/images/filter.png";
import "../../Common/Styles/Report.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import "../../Common/Styles/Listing.css";
import FilterModel from "./FilterModel";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import {
  getAllBookings,
  getCompleteBookings,
  getSingleBooking,
} from "../../../redux/booking/action";
import Completed from "./Completed";
import Upcomingbookings from "./Upcomingbookings";
import Spinner from "../../Layouts/Spinner";

export default function BookingList() {
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const bookings = useSelector((state) => state?.bookingSlice?.bookingList);
  const pagination = bookings?.pagination;
  const [loading, setLoading] = useState(false);

  console.log(bookings, "bookings--");
  // const handleTabChange = (type,page) => {
  //     setParams((prev) => ({ ...prev, type ,page:1}));
  // };
  const handleTabChange = (type) => {
    setLoading(true);
    setParams({
      page: 1,
      type,
      search_key: "",
      startdate: "",
      enddate: "",
      status: "",
      service_type: "",
      user_id: "",
    });
  };

  const [params, setParams] = useState({
    page: 1,
    type: 1,
    search_key: "",
    startdate: "",
    enddate: "",
    status: "",
  });

  // useEffect(() => {
  //     dispatch(getSingleBooking(params))
  // }, [dispatch, params])

  useEffect(() => {
    dispatch(getCompleteBookings(params));
  }, [dispatch, params]);

  useEffect(() => {
    setLoading(true);
    dispatch(getAllBookings(params));
  }, [dispatch, params]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setParams((prevParams) => ({
      ...prevParams,
      [name]: value,
      ...(name === "search_key" && { page: 1 }),
    }));
  };

  const viewComponent = (order_id) => {
    dispatch(getSingleBooking(order_id));
    toggleModal();
  };
  const bookingItem = useSelector((state) => state.reusableSlice.singleBooking);
  console.log(bookingItem, "single");
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  return (
    <div className="card-head">
      <div className="sub-head">
        <h4>Order List</h4>
      </div>
      <div
        className="filter-thing d-flex justify-content-between align-items-center"

      >
        <div className="d-flex listing-first col-md-6 p-0">
          <div className="search-bar d-flex w-100">
            <button><img src={search} alt="Search Icon" /></button>
            <input
              className="form-control search-input"
              type="search"
              name="search_key"
              placeholder="Search..."
              value={params.search_key}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <Modal isOpen={modal} toggle={() => setModal(!modal)}>
          <FilterModel
            modal={modal}
            setModal={setModal}
            params={params}
            setParams={setParams}
          />
        </Modal>
      </div>
      <div className="table-category ">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-end align-items-center table-right">
            Filter by
            <select

            >
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
          </div>
        </div>
        <div className="table-sec">
          <table className="table">
            <thead>
              <tr>
                <th>SR No</th>
                <th>Created On</th>
                <th>Updated On</th>
                <th>Payment Method</th>
                <th>Coupon Code</th>
                <th>Sub Total</th>
                <th>VAT</th>
                <th>Total</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bookings.orders?.length > 0 ? (
                bookings.orders.map((item, index) => (
                  <tr key={index}>
                    <td> {index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item.created_on.split(" ")[0]}</td>
                    <td>{item.updated_on.split(" ")[0]}</td>
                    <td>{item.payment_methord === 1 ? "online" : "COD"}</td>
                    <td>{item.coupon_code}</td>
                    <td>{item.total_cost_excluding_vat}</td>
                    <td>{item.vat}</td>
                    <td>{item.final_price}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="background-button"
                        onClick={() => viewComponent(item.order_id)}
                      >
                        <span><i className="fa fa-eye"></i></span>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-reports text-center">
                    No ratings found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="">
        <Modal isOpen={isModalOpen} className='cart-modal wishlist-modal-width' toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>Order Details</ModalHeader>
          <ModalBody>
            {bookingItem ? (
              <div className="">
                <div className="row">
                  <div className=" cart-modal-left col-md-5">
                    <h6><span>Customer Name :</span> {bookingItem.contact_name} </h6>
                    <h6><span>Contact Number :</span> {bookingItem.contact_number} </h6>
                    <h6><span>Address :</span> {bookingItem.address}</h6>
                    <h6><span>Ordered On : </span>{bookingItem.created_on}</h6>
                    <h6><span>Pickup date :</span> {bookingItem.pickupdate}</h6>
                    <h6><span>Updated on :</span> {bookingItem.updated_on}</h6>
                    <h6>
                      <span>Delivery type :</span>{" "}
                      {bookingItem.delivery_type === 1
                        ? "Deliver to me "
                        : "Leave at a spot"}
                    </h6>
                    <h6><span>Leave where :</span> {bookingItem.leave_where}</h6>
                    <h6>
                      <span>Payment type :</span>{" "}
                      {bookingItem.payment_method === 1 ? "COD" : "Online"}
                    </h6>
                    <h6><span>Additional Note :</span> {bookingItem.additional_note}</h6>
                    {bookingItem.order_status?.map((item) => (
                      <div

                        key={item.product_name}
                      >
                        <div className="">
                          <h6><span>Created on :</span> {item.created_on}</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="col-md-7">
                    <div className='table-category '>
                      <div className="table-first-top d-flex justify-content-between align-items-center">
                        <h4 style={{ fontSize: '18px' }}>Ordered Items</h4>
                        <div className="d-flex justify-content-end align-items-center table-right">
                          
                        </div>
                      </div>
                      <div
                        className="table-sec"

                      >
                        <table className="table">
                          <thead>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Price</th>
                          </thead>
                          <tbody>
                            {bookingItem.order_items?.map((item) => (
                              <tr key={item.product_name}>
                                <td>{item.product_name}</td>
                                <td>{item.quantity}</td>
                                <td>{item.final_price}</td>
                              </tr>
                            ))}

                          </tbody>
                        </table>
                      </div>
                      <div className="modal-total">
                        <h6><span>Sub Total :</span> {bookingItem.total_cost_excluding_vat}</h6>
                        <h6><span>VAT:</span> {bookingItem.vat}</h6>
                        <h6><span>Coupon Code :</span> {bookingItem.coupon_code}</h6>
                        <h6><span>Total :</span> {bookingItem.final_price}</h6>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            ) : (
              <p>Loading...</p>
            )}
          </ModalBody>
        </Modal>
      </div>
      {/* Pagination Component */}
      <div className="pagination-section">
        {pagination && (
          <CommonPagination
            currentPage={pagination.current_page}
            totalPages={pagination.pages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div >
  );
}
